export const createRandomString = (length: number): string => {
  return Math.random()
    .toString(16)
    .substring(2, length + 2);
};
